module.exports = __webpack_public_path__ + "static/carousel-10-17602c42f5913b47e8e94f262d50db8f.jpg";